<template>
    <div class="flex flex-col min-h-screen bg-canvas text-ink">
        <MainHeader class="sticky top-0 z-10"/>

        <main class="page-container flex flex-col grow py-12">
            <slot/>
        </main>

        <DefaultFooter/>
    </div>
</template>

<script lang="ts" setup>
const themeClass = useThemeClass()

useHead(() => ({
    htmlAttrs: {
        class: themeClass.value
    }
}))
</script>
